// extracted by mini-css-extract-plugin
export default {"container":"Ball_container__IJ5Lh","moveAround":"Ball_moveAround__kiIpX"};